
import { styled } from '@mui/material/styles';
import MuiTableCell from '@mui/material/TableCell';
import EDBox from '../../EDBox/EDBox';

export const EDStickyTableHeaderStickyCell: React.FC<
  React.PropsWithChildren
> = props => (
  <StyledTableCell>
    <StyledBox>{props.children}</StyledBox>
  </StyledTableCell>
);

const StyledTableCell = styled(MuiTableCell, {
  name: 'StickyTableHeaderStickyCell',
})(({ theme }) => ({
  width: 'var(--first-col-width)',
  boxSizing: 'border-box',
  padding: 0,
  border: 0,
  position: 'var(--first-col-position)' as React.CSSProperties['position'],
  left: 0,
  zIndex: 9,
  backgroundColor: `var(--first-cell-background, ${theme.palette.background.paper})`,
}));

const StyledBox = styled(EDBox, { name: 'StickyTableHeaderStickyCellContent' })(
  ({ theme }) => ({
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    padding: 'var(--first-cell-padding, 0)',
    overflow:
      'var(--first-cell-overflow, hidden)' as React.CSSProperties['overflow'],
    borderRight: `1px solid ${theme.customProperties.DataGrid.gridBorderColor}`,
    borderBottom: `1px solid ${theme.customProperties.DataGrid.gridBorderColor}`,
    display: 'flex',
    flexDirection:
      'var(--first-cell-direction, column)' as React.CSSProperties['flexDirection'],
    justifyContent: 'var(--first-cell-alignment, center)',
    alignItems: 'var(--first-cell-verticalAlignment, center)',
    textAlign:
      'var(--first-cell-textAlignment, center)' as React.CSSProperties['textAlign'],
  })
);
